import { API_V1 } from 'API/APIs/APIv1';
import _ from 'lodash';
import Logger from 'logger';

export const getLinkedinCompanies = async (query: string, lang: string, linkedinAccount: string | undefined) => {
  try {
    const response = await API_V1.post(
      '/linkedin/lookups/company',
      {
        linkedinAccount,
      },
      {
        params: {
          query,
          lang,
        },
      }
    );

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting LinkedIn companies!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
